import React from 'react';

import { PageButton } from './page-button.component';

type PageNumbersProps = {
  pageIndex: number;
  pages: number[];
  onPageClick: (value: number) => void;
};

export const PageNumbers = ({
  pageIndex,
  pages,
  onPageClick,
}: PageNumbersProps): JSX.Element => (
  <>
    {pages.map((page) => (
      <PageButton
        isActive={pageIndex + 1 === page}
        key={page}
        label={`Page ${page}`}
        onClick={() => onPageClick(page - 1)}
      >
        {page}
      </PageButton>
    ))}
  </>
);
